import React from "react";
import { styles } from "./TutorSubjectStyles";
import { Flex, HStack, Text, Box, VStack } from "@chakra-ui/react";

const RowItem = ({ item, isSelected, onClick, width, isEnabled }) => {
  return (
    <HStack
      {...styles.button(isSelected, width)}
      onClick={() => onClick?.(item)}
    >
      <Text {...styles.buttonText(isSelected, isEnabled)}>{item}</Text>
    </HStack>
  );
};
export default RowItem;
